import { useEffect, useState } from 'react';
import { ChevronRight } from 'lucide-react';
import { useStore } from '@tanstack/react-store';
import { selectedLanguageStore, setSelectedLanguage } from '../../../stores/selectedLanguage';
import { useListLanguages } from '../../../hooks/useLanguages';
import { useGetCommonContentQuery, useUpdateCommonContent } from '../../../hooks/useCommon';
import { useQueryClient } from '@tanstack/react-query';
import TextEditor from '../../common/joditEditor';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import toast from 'react-hot-toast';

const Privacy = () => {
    const { selectedLanguage } = useStore(selectedLanguageStore)
    const [languages, setLanguages] = useState([]);
    const [privacy, setPrivacy] = useState('');
    const queryClient = useQueryClient();
    const updateCommonContentMutation = useUpdateCommonContent()
    const { data: languagesListResponse, isSuccess: isSuccessLanguagesList } = useListLanguages('')
    const { data: commonData, isSuccess: isSuccessCommonData } = useGetCommonContentQuery(`?type=privacy_policy&language=${selectedLanguage}`)
    
    const savePrivacy = () => {
        updateCommonContentMutation.mutate({
            content: privacy,
            type: "privacy_policy",
            language: selectedLanguage
        }, {
            onSuccess: () => {
                toast.success("Privacy Content Saved Successfully")
                queryClient.invalidateQueries({ queryKey: ['common_content'] });
            },
            onError: (error) => {
                const message = error.response?.data?.message
                toast.error(message)
            }
        })
    }

    useEffect(() => {
        if(isSuccessCommonData) {
            setPrivacy(commonData?.data?.data?.content)
        }
    }, [isSuccessCommonData, commonData])

    useEffect(() => {
        if (isSuccessLanguagesList) {
            setLanguages(languagesListResponse?.data?.data?.result)
        }
    }, [languagesListResponse, isSuccessLanguagesList])

    return (
        <div className="flex h-screen bg-white text-gray-800">
            <div className="flex-1 flex flex-col overflow-hidden">
                <div className="bg-gray-50 border-b border-gray-200 p-1 flex items-center">
                    <div className="text-sm text-gray-500 flex items-center">
                        <span className="hover:text-blue-600 cursor-pointer">Dashboard</span>
                        <ChevronRight size={14} className="mx-2" />
                        <span className="hover:text-blue-600 cursor-pointer">Text Settings</span>
                        <ChevronRight size={14} className="mx-2" />
                        <span className="text-gray-700">Privacy Policy</span>
                    </div>
                </div>
                <div className="flex-1 overflow-auto p-6">
                    <div className="flex justify-between items-center mb-2">
                        <div>
                            <h1 className="text-2xl font-bold">Privacy Policy</h1>
                            <p className="text-gray-500">Update your website's privacy policy to reflect the latest data practices and compliance standards. Be clear and transparent with your users about how their information is handled.</p>
                        </div>
                        <button
                            onClick={() => savePrivacy()}
                            className="bg-gray-800 hover:bg-gray-900 text-white px-4 py-2 rounded">
                            Save
                        </button>
                    </div>
                    <div className="mb-6 flex space-x-2">
                        {languages.map(language => (
                            <button
                                key={language?.short_code}
                                className={`px-4 py-2 rounded ${selectedLanguage === language?.short_code ? 'bg-gray-900 text-gray-200' : 'bg-white text-gray-600'}`}
                                onClick={() => setSelectedLanguage(language?.short_code)}>
                                {language?.name}
                            </button>
                        ))}
                    </div>
                    <div className="w-full border border-gray-200 rounded-t p-2 flex items-center space-x-2 bg-white">
                        <TextEditor
                            content={privacy}
                            setContent={setPrivacy}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
export default Privacy;